import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';

import { ModalControl } from '../../../modal-control/modal-control.component';
import { SettingService } from '../../../../services/setting/setting.service';
import { GridOption, GridColumn, GridItem } from '../../grid-control.model';

@Component({
  selector: 'sd-grid-popup-editor',
  templateUrl: './grid-popup-editor.component.html',
  styleUrls: ['../../../../assets/css/button.scss',
    '../../../../assets/css/scrollbar.scss']
})
export class GridPopupEditorComponent implements OnInit {

  @ViewChild('modal') modal: ModalControl;
  @Output() save = new EventEmitter<GridItem>();
  columns: GridColumn[] = [];
  gridOption: GridOption;
  item: GridItem;

  constructor(private settingService: SettingService) { }

  ngOnInit() {
  }

  setGridOption(gridOption: GridOption) {
    this.gridOption = gridOption;
  }

  open(item: GridItem) {
    this.item = item;
    this.columns = this.gridOption.columns.filter(column => item.editorHandler[column.field].visible);
  }

  onCancel() {
    this.modal.close();
  }

  onSave() {
    this.modal.close();
    this.save.emit(this.item);
  }
}
